import { ReactComponent as EditIcon } from "assets/icons/edit.svg";
import { ButtonBase } from "@mui/material";
import { UserDetailsDto } from "dto";
import { useState } from "react";
import { EditRoleDialog } from "./EditRoleDialog";

export const EditRoleButton = ({ user }: { user: UserDetailsDto }) => {
  const [isRoleEditDialogOpen, setIsRoleEditDialogOpen] = useState(false);
  return (
    <>
      <ButtonBase
        onClick={() => setIsRoleEditDialogOpen(true)}
        sx={{ borderRadius: 1, p: 1 }}
      >
        <EditIcon />
      </ButtonBase>
      <EditRoleDialog
        open={isRoleEditDialogOpen}
        user={user}
        onClose={() => setIsRoleEditDialogOpen(false)}
      />
    </>
  );
};
